import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=230bf439&scoped=true&"
import script from "./Brands.ts?vue&type=script&lang=ts&"
export * from "./Brands.ts?vue&type=script&lang=ts&"
import style0 from "./Brands.scss?vue&type=style&index=0&id=230bf439&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230bf439",
  null
  
)

export default component.exports